import jsPDF from "jspdf";
import { format, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";

const addWrappedText = (doc, text, x, y, maxWidth, lineHeight) => {
  const lines = doc.splitTextToSize(text || "", maxWidth);
  lines.forEach((line) => {
    if (y > 280) {
      doc.addPage();
      y = 20;
    }
    doc.text(line, x, y);
    y += lineHeight;
  });
  return y;
};

export const exportEspelhoPDF = (ep) => {
  const doc = new jsPDF({ unit: "mm", format: "a4" });
  const W = 210, M = 18, maxW = W - M * 2;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(20);
  doc.text("Notícias de Quinta", M, 22);
  doc.setFontSize(11);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(80);
  doc.text(
    `Espelho — ${format(parseISO(ep.date), "EEEE, dd 'de' MMMM 'de' yyyy", { locale: ptBR })}`,
    M, 29
  );
  doc.setDrawColor(0);
  doc.line(M, 33, W - M, 33);

  let y = 42;
  ep.retrancas.forEach((r, i) => {
    if (y > 270) { doc.addPage(); y = 20; }
    doc.setTextColor(0);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(13);
    const head = `${String(i + 1).padStart(2, "0")}. ${r.title}  [${r.type}]`;
    doc.text(head, M, y);
    y += 6;

    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.setTextColor(90);
    const meta = [
      r.presenter && `Apresentador: ${r.presenter}`,
      r.responsible && `Responsável: ${r.responsible}`,
      `Status: ${r.approved ? "Aprovado" : "Em edição"}`,
    ].filter(Boolean).join("  ·  ");
    doc.text(meta, M, y);
    y += 6;

    doc.setTextColor(0);
    doc.setFontSize(10);
    y = addWrappedText(doc, r.text || "(sem texto)", M, y, maxW, 5);
    if (r.overlays_url) {
      y += 2;
      doc.setFontSize(8);
      doc.setTextColor(0, 47, 167);
      doc.setFont("helvetica", "bold");
      doc.text("TARJA:", M, y);
      doc.setFont("helvetica", "normal");
      doc.setTextColor(60);
      y = addWrappedText(doc, ` ${r.overlays_url}`, M + 14, y, maxW - 14, 4);
    } else if (r.tarja_chapeu || r.tarja_linha1 || r.tarja_linha2) {
      // Legacy tarja fallback for older episodes
      y += 2;
      doc.setFontSize(8);
      doc.setTextColor(0, 47, 167);
      doc.setFont("helvetica", "bold");
      doc.text("TARJA:", M, y);
      y += 4;
      doc.setFont("helvetica", "normal");
      doc.setTextColor(60);
      if (r.tarja_chapeu) { y = addWrappedText(doc, `Chapéu: ${r.tarja_chapeu}`, M, y, maxW, 4); }
      if (r.tarja_linha1) { y = addWrappedText(doc, `L1: ${r.tarja_linha1}`, M, y, maxW, 4); }
      if (r.tarja_linha2) { y = addWrappedText(doc, `L2: ${r.tarja_linha2}`, M, y, maxW, 4); }
    }
    y += 6;
    doc.setDrawColor(220);
    doc.line(M, y, W - M, y);
    y += 6;
  });

  doc.save(`espelho-${ep.date}.pdf`);
};

export const exportTeleprompterPDF = (ep) => {
  const doc = new jsPDF({ unit: "mm", format: "a4" });
  const W = 210, M = 18, maxW = W - M * 2;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(18);
  doc.text(`Teleprompter — ${ep.title}`, M, 22);
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.setTextColor(90);
  doc.text(format(parseISO(ep.date), "PPP", { locale: ptBR }), M, 28);

  let y = 38;
  ep.retrancas.forEach((r, i) => {
    if (y > 270) { doc.addPage(); y = 20; }
    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(0, 47, 167);
    doc.text(`${String(i + 1).padStart(2, "0")} · ${r.type} · ${r.title}`, M, y);
    y += 7;
    doc.setFont("helvetica", "normal");
    doc.setTextColor(0);
    doc.setFontSize(14);
    y = addWrappedText(doc, r.text || "(sem texto)", M, y, maxW, 7);
    y += 10;
  });

  doc.save(`teleprompter-${ep.date}.pdf`);
};
